module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/desempeno-greyLight.c30cfd5f.svg";